import type { ReactNode } from "react";
import type { CaseVisual } from "../content/experience";

const visuals: Record<CaseVisual, ReactNode> = {
  app: (
    <svg viewBox="0 0 64 64" fill="none" aria-hidden>
      <rect x="12" y="10" width="40" height="44" rx="8" stroke="currentColor" strokeWidth="2" />
      <path
        d="M20 43c5-15 11-17 17-9 3 4 6 4 7-1"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <circle cx="24" cy="21" r="3" fill="currentColor" />
    </svg>
  ),
  platform: (
    <svg viewBox="0 0 64 64" fill="none" aria-hidden>
      <path
        d="M32 20 18 44M32 20l14 24M21 46h22"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="32" cy="16" r="4.5" stroke="currentColor" strokeWidth="2" />
      <circle cx="16" cy="47" r="4.5" stroke="currentColor" strokeWidth="2" />
      <circle cx="48" cy="47" r="4.5" stroke="currentColor" strokeWidth="2" />
    </svg>
  ),
  device: (
    <svg viewBox="0 0 64 64" fill="none" aria-hidden>
      <rect x="20" y="30" width="24" height="22" rx="4" stroke="currentColor" strokeWidth="2" />
      <path
        d="M27 38h10M27 45h6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M23 24a12 12 0 0 1 18 0M17 17a21 21 0 0 1 30 0"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
};

export function CaseStudyVisual({ type }: { type: CaseVisual }) {
  return <div className="case-visual">{visuals[type]}</div>;
}
